import * as Yup from "yup";
import i18next from "i18next";

const phoneRegExp = /^[0-9]{10,15}$/;

export const UpdateProfileSchema = () => Yup.object({

    first_name: Yup.string().required(i18next.t('profile.error_fname')),
    last_name: Yup.string().required(i18next.t('profile.error_lname')),
    gender: Yup.string().required(i18next.t('profile.error_gender')),
    username: Yup.string().required(i18next.t('profile.error_username')),
    email: Yup.string().email().required(i18next.t('profile.error_email')),
    mobile_number: Yup.string().matches(phoneRegExp, i18next.t('profile.error_invalid_mobile')).required(i18next.t('profile.error_mobile')),
    dob: Yup.string().nullable().notRequired(i18next.t('profile.error_dob')),
    profile: Yup.mixed().notRequired(i18next.t('profile.error_profile')),

});

export const FamilyMemberSchema = () => Yup.object({

    first_name: Yup.string().required(i18next.t('profile.error_fname')),
    last_name: Yup.string().required(i18next.t('profile.error_lname')),
    gender: Yup.string().required(i18next.t('profile.error_gender')),
    username: Yup.string().required(i18next.t('profile.error_username')),
    email: Yup.string().email(i18next.t('profile.error_email')).notRequired(i18next.t('profile.error_email')),
    mobile_number: Yup.string().matches(phoneRegExp, i18next.t('profile.error_invalid_mobile')).notRequired(i18next.t('profile.error_mobile')),
    dob: Yup.string().nullable().notRequired(),
    profile: Yup.mixed().notRequired(),

});